import { render } from "./JobDetailView.vue?vue&type=template&id=2d6b6180&scoped=true"
import script from "./JobDetailView.vue?vue&type=script&lang=js"
export * from "./JobDetailView.vue?vue&type=script&lang=js"

import "./JobDetailView.vue?vue&type=style&index=0&id=2d6b6180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6b6180"]])

export default __exports__